import { combineReducers } from 'redux';

import data from './data/reducer';
import item from './item/reducer';
import comment from './comment/reducer';
import order from './order/reducer';

export default combineReducers({
  data,
  item,
  comment,
  order,
});
